/* eslint-disable */
/* This file is auto-generated. Do not edit this file directly. */

/*
 * This file contains an index of all the routes in the app. It can help to
 * catch broken links at build time. If a route is moved or removed, any
 * references to its original key in this file will raise an error.
 */

export const dialogs = {
  ClientBlockDialogPage: '/org/:companyName/network/:networkSlug/insights/clients/:macAddress/block',
  ClientUnblockDialogPage: '/org/:companyName/network/:networkSlug/insights/clients/:macAddressOrOUI/unblock',
  HostMonitoringTargetDeletePage: '/org/:companyName/network/:networkSlug/insights/host-monitoring/:targetUUID/delete',
  MutationDiffAuditLogSummaryPage: '/org/:companyName/network/:networkSlug/logs/audit-log/:mutationAuditLogEntryUUID',
  WiFiCredentialsPage: '/org/:companyName/network/:networkSlug/tools/wifi-credentials',
  ReleaseNotesDialogPage: '/org/:companyName/settings/org/:networkSlug/networks/release-notes/:major/:minor/:patch',
} as const;